import { render } from "./MbaInterna.vue?vue&type=template&id=d07ba614"
import script from "./MbaInterna.vue?vue&type=script&lang=js"
export * from "./MbaInterna.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__